import React, { useState, useEffect } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Form,  Row, Col } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import { Options } from "../risks/iso-verklaringen";
import { useAppContext } from "../AppContext";
import { expandCategories, getCategoryValue } from "../common/helpers";

function MeasureModal({ measureObj, show, handleClose, uniqueOwners }) {
    const { t, i18n } = useTranslation();
    const { currentOrg } = useAppContext();
    const language = i18n.language;
    const [ownerOptions, setOwnerOptions] = useState([]);
    const [categories, setCategories] = useState([]);
    const [owner, setOwner] = useState();

    useEffect(() => {
        if(measureObj && measureObj.category) {
          // Expand categories (string IDs or objects) to full {value, label} for Typeahead
          setCategories(expandCategories(measureObj.category, language, currentOrg.securityStandard));
        }

        if(measureObj)
          setOwner(measureObj?.owner);

        
        setOwnerOptions(uniqueOwners || []);
    }, [measureObj, uniqueOwners]);

    const handleOwnerTypeahead = (e) => {
      // if typeof e is array with length 0 then return 
      if (Array.isArray(e) && e.length === 0) {
          return;
      }

      // if e is a string that's the owner, otherwise if e[0].owner exists thats the owner, otherwise e[0] is the owner
      let value = typeof e === 'string' ? e : e[0].owner ? e[0].owner : e[0];

      setOwner(value);
      
    };

    const handleChange = (selected) => {
        setCategories(selected);
    };

    if (measureObj) {

    return (
      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title>{t('update')} {t('measure').toLowerCase()}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="update-score-modal">
            <Form id="updateMeasure">

                <Row className="mb-3" >
                    <Col>{t('risk')}</Col>
                    <Col lg="8"><Form.Control as="textarea" defaultValue={measureObj.riskDescription} rows={Math.min(8, Math.max(3, Math.ceil((measureObj.riskDescription || '').length / 60)))} disabled style={{ resize: 'vertical' }} /></Col>
                </Row>

                <Row className="mb-3" >

                    <Col>{t('measure')}</Col>
                    <Col lg="8"><Form.Control as="textarea" name="measure" defaultValue={measureObj.measure} rows={3} /></Col>

                </Row>

                <Row className="mb-3" >

                    <Col>{t('category')}</Col>

                    <Col lg="8">
                        <Typeahead
                        id={"basic-typeahead-multiple-" + measureObj.riskId}
                        labelKey="label"
                        multiple
                        onChange={handleChange}
                        options={Options(language, currentOrg.securityStandard).filter(
                            opt => !(categories || []).some(sel => getCategoryValue(sel) === opt.value)
                        )}
                        placeholder={t('category_placeholder')}
                        selected={categories}
                        name="category"
                        />
        
                    </Col>

                </Row>

                <Row className="mb-3" >

                    <Col>{t('measure')} status</Col>
                    <Col lg="8">
                        <Form.Select name={"status"} defaultValue={measureObj.status}>
                            <option value="">Status</option>
                            <option value="todo">{t('todo')}</option>
                            <option value="in_progress">{t('in_progress')}</option>
                            <option value="on_hold">{t('on_hold')}</option>
                            <option value="implemented">{t('implemented')}</option>
                            <option value="dismissed">{t('dismissed')}</option>
                        </Form.Select>
                    </Col>

                </Row>

                <Row className="mb-3" >
                    <Col>{t('measure_owner')}</Col>
                    <Col lg="8">

                      <Typeahead
                          id={"basic-typeahead-owner-single"}
                          labelKey="owner"
                          onChange={handleOwnerTypeahead}
                          onInputChange={handleOwnerTypeahead}
                          options={ownerOptions}
                          placeholder={" " + t('measure_owner_placeholder')}
                          allowNew
                          newSelectionPrefix={t('new_measure_owner') + ": "}
                          selected={owner ? [{ owner: owner }] : []}
                          name="owner"
                          inputProps={{ required: true }}
                      /> 
                    </Col>
                </Row>

                <Row className="mb-3" >
                    <Col>Deadline {t('date').toLowerCase()}</Col>
                    <Col lg="8"><Form.Control type="date" name="deadlineDate" defaultValue={measureObj.deadlineDate}  /></Col>
                </Row>

                <Row className="mb-3" >
                    <Col>{t('link_to_actions')}</Col>
                    <Col lg="8"><Form.Control as="textarea" name="action" defaultValue={measureObj.action} rows="3" /></Col>
                </Row>
                
            </Form>
        </Modal.Body>

        <Modal.Footer>
          <div className="white-border-btn cancel-btn" onClick={() => handleClose(false)}>
            {t('cancel')}
          </div>
          <div className="white-border-btn submit-btn" onClick={() => handleClose(true, measureObj.riskId, {
            "index": measureObj.measureIndex,
            "measure": document.querySelector('textarea[name="measure"]').value,
            "category": categories,
            "status": document.querySelector('select[name="status"]').value || "",
            "owner": owner,
            "deadlineDate": document.querySelector('input[name="deadlineDate"]').value,
            "action": document.querySelector('textarea[name="action"]').value
          })}> 
            {t('update')}
          </div>
        </Modal.Footer>
      </Modal>
    );
  } 
}

export default MeasureModal;
